import {Currency} from '../../models/Currencies';

export type CurrencyStore = { currency?: Currency };
export const initialState: CurrencyStore = {
  currency: undefined,
};
